/**
 * @file helpscene.js
 * @desc This module contains HelpScene class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

// depends on global PIXI

var Scene = require('scene').Scene;

// var HelpInterface = require('helpinterface').HelpInterface;

// var helpInterfaceConfig = require('cfg/helpinterface-config');

var versionInfo = require('src/version');

var screenConfig = require('cfg/screen-config');

(/** @lends <global> */function (global) {
    'use strict';

    /**
     * Constructs HelpScene.
     * @class
     * @constructor
     * @param {Object} controller The delegate which handles scene events
     * @param {Object} model Slot model as part of data source
     * @param {Object} math Game mathematics as data source for price table representation
     * @param {Object} config Scene configuration
     * @name HelpScene
     * @classdesc This is a ready to use fully configurable GUI component.
     * @extends Scene
     * @tutorial 2.0-adding-help-scene
     * */
    var HelpScene = function(controller, model, math, config) {
        Scene.call(this);


        this.interactive = true;
        this.buttonMode = true;

        // this.model = model;
        this.math = math;
        this.config = config;

        this._pagesNumber = this.config.pages;

        this.pages = [];

        for (var i = 0; i < this._pagesNumber; ++i) {
            var page = new PIXI.Sprite(PIXI.utils.TextureCache[this.config.pageNameFormat.$(i)]);
            page.visible = false;
            this.pages.push(page);
            this.addChild(page);

            if (i == 0) {
                this.preparePricetable();
            }
        }

        this._currentPage = 0;

        this.pages[this._currentPage].visible = true;

        // this.helpInterface = new HelpInterface(this/*parent node*/, controller/*delegate*/, this/*help data source*/, helpInterfaceConfig);

        this.sndAmbient = this.config.backgroundMusic ? sounds.get( this.config.backgroundMusic ) : null;
        if (this.sndAmbient) {
            this.sndAmbient.loop( true );
        }

        this.sndClick = this.config.click ? sounds.get( this.config.click ) : null;


        this.versionInfoLabel = new PIXI.Text("build " + versionInfo.build,
            {   fontFamily:"Arial",
                fontSize:"12px",
                fill:"white",
                align:"right",
                dropShadow:true,
                dropShadowColor:"black",
                dropShadowAngle:Math.PI/4,
                dropShadowDistance:2
            });
        this.versionInfoLabel.position.set(screenConfig.resolution.width - 24, screenConfig.resolution.heigth - 16);
        this.versionInfoLabel.anchor.set(1,0);
        this.pages[0].addChild(this.versionInfoLabel);
        // this.versionInfoLabel.visible = false;

        this.visible = false;
    };

    HelpScene.prototype = Object.create(Scene.prototype);

    HelpScene.prototype.constructor = HelpScene;

    HelpScene.prototype.terminate = function() {

        if (this.currentPageTween) {
            this.currentPageTween.kill();
        }

        this.removeChildren();
        this.destroy();

        this.math = null;
        this.config = null;
        this.pages = null;
        this.priceLabels = null;

        if (this.sndAmbient) {
            this.sndAmbient.stop();
            this.sndAmbient = null;
        }

        this.sndClick = null;

        this.versionInfoLabel = null;
    };


    /**
     * Returns help pages number.
     * @returns {Number} Pages number
     * @memberOf HelpScene
     * */
    HelpScene.prototype.getPagesCount = function () {
        return this._pagesNumber;
    };

    /**
     * Returns current page number.
     * @returns {Number} Current page number
     * @memberOf HelpScene
     * */
    HelpScene.prototype.getCurrentPage = function () {
        return this._currentPage;
    };

    /**
     * Slides pages to next page.
     * @memberOf HelpScene
     * */
    HelpScene.prototype.nextPage = function(done) {
        if (this._currentPage < this.getPagesCount() - 1) {

            if (this.sndClick) {
                this.sndClick.play();
            }

            // this.helpInterface.disable();

            var currentPage = this._currentPage;
            var nextPage = currentPage + 1;


            var self = this;

            this.pages[nextPage].visible = true;
            this.pages[nextPage].x = screenConfig.resolution.width;

            if (this.currentPageTween) {
                this.currentPageTween.stop();
            }
            this.currentPageTween = new TWEEN.Tween(this.pages[currentPage])
                .to({ x: -screenConfig.resolution.width}, 1000)
                .easing(TWEEN.Easing.Cubic.InOut)
                .onUpdate(function() {
                    this.pages[nextPage].x = this.pages[currentPage].x + this.pages[currentPage].width;
                }.bind(this))
                .onComplete(function() {
                    self._currentPage = nextPage;
                    self.pages[currentPage].visible = false;
                    // self.helpInterface.updateButtonsState();
                    done();
                })
                .start();
        }
        else {
            done();
        }
    };

    /**
     * Slides pages to previous page.
     * @memberOf HelpScene
     * */
    HelpScene.prototype.previousPage = function(done) {
        if (this._currentPage > 0) {

            if (this.sndClick) {
                this.sndClick.play();
            }

            var currentPage = this._currentPage;
            var previousPage = currentPage - 1;

            var self = this;

            this.pages[previousPage].visible = true;
            this.pages[previousPage].x = -screenConfig.resolution.width;

            if (this.currentPageTween) {
                this.currentPageTween.stop();
            }
            this.currentPageTween = new TWEEN.Tween(this.pages[currentPage])
                .to({ x: screenConfig.resolution.width}, 1000)
                .easing(TWEEN.Easing.Cubic.InOut)
                .onUpdate(function () {
                    this.pages[previousPage].x = this.pages[currentPage].x - this.pages[previousPage].width;
                }.bind(this))
                .onComplete(function() {
                    self.pages[currentPage].visible = false;
                    self._currentPage = previousPage;
                    // self.helpInterface.updateButtonsState();
                    done();
                })
                .start();
        }
        else {
            done();
        }
    };


    HelpScene.prototype.update = function(dt, time) {

        Scene.prototype.update(dt, time);

        // this.versionInfoLabel.visible = PIXI.keyboardManager.isDown(PIXI.keyboard.Key.B);
    };


    /**
     * Pauses scene.
     * @memberOf HelpScene
     * @override
     * */
    HelpScene.prototype.pause = function() {
        Scene.prototype.pause.call(this);

        this.pages[this._currentPage].visible = false;
        this._currentPage = 0;

        // this.helpInterface.disable();

        if (this.sndAmbient) {
            this.sndAmbient.stop();
        }

        if (this.sndClick) {
            this.sndClick.play();
        }
    };

    /**
     * Resumes scene.
     * @memberOf HelpScene
     * @override
     * */
    HelpScene.prototype.resume = function() {
        Scene.prototype.resume.call(this);

        this._currentPage = 0;
        this.pages[this._currentPage].visible = true;
        this.pages[this._currentPage].position.set(0,0);
        // this.helpInterface.show();
        // this.helpInterface.updateButtonsState();

        // RX
        // this.updatePricetable();

        if (this.sndAmbient) {
            this.sndAmbient.mute(false)
            this.sndAmbient.play();
        }

        if (this.sndClick) {
            this.sndClick.mute(false);
        }
    };

    /**
     * Makes price table.
     * @memberOf HelpScene
     * @private
     * */
    HelpScene.prototype.preparePricetable = function () {

        this.prices = {};

        for (var i = 0, max = this.config.pricetable.length; i < max; ++i) {
            var symbol = this.config.pricetable[i].symbol;
            var wins = this.config.pricetable[i].wins;
            var startPosition = this.config.pricetable[i].position;
            var offset = this.config.pricetable[i].offset;
            var align = this.config.pricetable[i].align || 'center';

            this.prices[symbol] = {price:[]};

            for (var j = 0; j < wins.length; ++j) {
                var label = new PIXI.extras.BitmapText( '0', {font: this.config.priceFontName, align:align});
                this.pages[0].addChild(label);

                var x;
                var y;
                //if object with x and y values:
                if ( ! isNaN( startPosition.x ) )
                {
                    x = startPosition.x;
                    y = startPosition.y;
                }
                //otherwise array of such objects is expected:
                else
                {
                    x = startPosition[ j ].x;
                    y = startPosition[ j ].y;
                }

                label.x = x + ( offset ? offset.width : 0 ) * j;
                label.y = y + ( offset ? offset.height : 0 ) * j;

                switch (align) {
                    case 'left':
                        label.anchor.set(0.0, 0.0);
                        break;

                    case 'right':
                        label.anchor.set(1.0, 0.0);
                        break;

                    case 'center':
                        label.anchor.set(0.5, 0.0);
                        break;

                    default:
                        label.anchor.set(0.5, 0.0);
                        break;
                }

                this.prices[symbol].price.push(label);
            }
        }
    };

    /**
     * Updates price table values.
     * @memberOf HelpScene
     * */
    HelpScene.prototype.updatePricetable = function (lines, multiplier) {
        for (var i = 0, max = this.config.pricetable.length; i < max; ++i) {
            var symbol = this.config.pricetable[i].symbol;
            var wins = this.config.pricetable[i].wins;
            for (var j = 0; j < wins.length; ++j) {
                var winValue = this.math.price(symbol, wins[j]);
                if (symbol == this.math.scatter) {
                    // RX
                    winValue *= lines * multiplier;
                }
                else {
                    // RX
                    winValue *= multiplier;
                }

                this.prices[symbol].price[j].text = winValue;
            }
        }
    };



    // RX

    HelpScene.prototype.show = function (bet) {
        this.visible = true;
        this.resume();
        this.updatePricetable(bet.lines, bet.multiplier);
    };

    HelpScene.prototype.hide = function () {
        this.visible = false;
        this.pause();
    };


    global.HelpScene = HelpScene;
}(typeof module === 'object' && module.exports || this));



//////////////////
// WEBPACK FOOTER
// ./src/library/helpscene.js
// module id = 30
// module chunks = 0